export const BrandData = [
   {name:"WOW Skin",count:422,type:"checkbox"},
   {name:"Maxisoft",count:266,type:"checkbox"},
   {name:"Vaadi Herbals",count:258,type:"checkbox"},
   {name:"Mirah Belle",count:246,type:"checkbox"},
   {name:"Pearldew",count:214,type:"checkbox"},
   {name:"VLCC",count:195,type:"checkbox"},
   {name:"Khadi Naturals",count:180,type:"checkbox"},
   {name:"St.Botanica",count:177,type:"checkbox"},
   {name:"inatur",count:163,type:"checkbox"},
   {name:"Naturoman",count:150,type:"checkbox"},
   {name:"Oshea Herbals",count:133,type:"checkbox"},
   {name:"Organic Harvest",count:130,type:"checkbox"},
   {name:"Vagad's Khadi",count:130,type:"checkbox"},
   {name:"Khadi India",count:126,type:"checkbox"},
   {name:"Aloe Veda",count:123,type:"checkbox"},
   {name:"Deve Herbes",count:120,type:"checkbox"},
   {name:"Nivea",count:116,type:"checkbox"},
   {name:"Tjori",count:111,type:"checkbox"},
]


export const ProductTagData = [
   {name:"Antioxidant",count:165,type:"checkbox"},
   {name:"Wrinkles",count:138,type:"checkbox"},
   {name:"Pores",count:135,type:"checkbox"},
   {name:"Pimple",count:134,type:"checkbox"},
   {name:"Complexion",count:120,type:"checkbox"},
   {name:"Blemishes",count:107,type:"checkbox"},
   {name:"Impurity",count:88,type:"checkbox"},
   {name:"Antibacterial",count:87,type:"checkbox"},
   {name:"Paraben",count:77,type:"checkbox"},
   {name:"Oily",count:76,type:"checkbox"},
   {name:"Moisturizer",count:70,type:"checkbox"},
   {name:"Cleanser",count:67,type:"checkbox"},
   {name:"Dryness",count:67,type:"checkbox"},
   {name:"Sunscreen",count:67,type:"checkbox"},
   {name:"Greasy",count:65,type:"checkbox"},
   {name:"Elasticity",count:63,type:"checkbox"},
   {name:"Khadi",count:62,type:"checkbox"},
   {name:"Eczema",count:60,type:"checkbox"}
]


export const DiscountData = [
   {name:"Less than 10%",count:5159,type:"radio"},
   {name:"10% and above",count:7912,type:"radio"},
   {name:"20% and above",count:3513,type:"radio"},
   {name:"30% and above",count:1714,type:"radio"},
]

export const ProductFormData = [
   {name:"Cream",count:2273,type:"checkbox"},
   {name:"Soap",count:2221,type:"checkbox"},
   {name:"Oil",count:2138,type:"checkbox"},
   {name:"Face Wash",count:1526,type:"checkbox"},
   {name:"Lotion",count:1405,type:"checkbox"},
   {name:"Bottle",count:964,type:"checkbox"},
   {name:"Gel",count:847,type:"checkbox"},
   {name:"Serum",count:771,type:"checkbox"},
   {name:"Pack",count:671,type:"checkbox"},
   {name:"Scrub",count:668,type:"checkbox"},
   {name:"Sanitizer",count:661,type:"checkbox"},
   {name:"Liquid",count:593,type:"checkbox"},
   {name:"Body Wash",count:553,type:"checkbox"},
   {name:"Kit",count:517,type:"checkbox"},
   {name:"Powder",count:384,type:"checkbox"},
   {name:"Tube",count:356,type:"checkbox"},
   {name:"Cleanser",count:301,type:"checkbox"},
   {name:"Face Mask",count:286,type:"checkbox"},
]



export const UsesData = [
   {name:"Skin Care",count:17260,type:'checkbox'},
   {name:"Hair Care",count:1170,type:'checkbox'},
   {name:"Daily living aids",count:990,type:'checkbox'},
   {name:"Baby Care",count:609,type:'checkbox'},
   {name:"Mind Care",count:524,type:'checkbox'},
   {name:"Men Care",count:207,type:'checkbox'},
   {name:"Bone, Joint",count:166,type:'checkbox'},
   {name:"Women Care",count:163,type:'checkbox'},
   {name:"Stomach Care",count:159,type:'checkbox'},
   {name:"Cardiac Care",count:103,type:'checkbox'},
   {name:"Cough & Cold",count:83,type:'checkbox'},
   {name:"Immunity Booster",count:68,type:'checkbox'},
   {name:"Disinfectants",count:62,type:'checkbox'},
   {name:"Eye & Ear Care",count:26,type:'checkbox'},
   {name:"Kidney Care",count:20,type:'checkbox'},
   {name:"Mother Care",count:20,type:'checkbox'},
   {name:"Sexual Wellness",count:20,type:'checkbox'},
   {name:"Liver Care",count:19,type:'checkbox'}
]


export const AgeData = [
   {name:"All",count:18031,type:"checkbox"},
   {name:"Child",count:683,type:"checkbox"},
   {name:"Adult",count:19,type:"checkbox"},
   {name:"Elderly",count:10,type:"checkbox"},
]

export const GenderData = [
   {name:"Unisex",count:18061,type:"checkbox"},
   {name:"Male",count:428,type:"checkbox"},
   {name:"Female",count:212,type:"checkbox"},
]
